export const objectDefaultsError = (items) => {
  const slots = new Set();
  let error = null;
  items.forEach((item) => {
    if (error) return;
    const { asset_category: category, surface } = item;
    if (category === 'material' && !['wall', 'floor', 'ceiling'].includes(surface)) {
      error = 'Укажите поверхность для каждого материала';
      return;
    }
    if (category === 'molding') {
      if (!['floor', 'ceiling'].includes(surface)) {
        error = 'Укажите назначение каждого молдинга';
        return;
      }
      const moldingType = item.asset?.molding_type;
      if (moldingType && ![surface, 'universal'].includes(moldingType)) {
        error = 'Молдинг не подходит для выбранной поверхности';
        return;
      }
    }
    if (!['material', 'molding', 'aperture'].includes(category)) return;
    const slot = category === 'aperture' ? item.aperture_type || item.asset?.aperture_type : surface;
    if (!slot) return;
    const key = `${item.purpose || 'required'}:${item.room_type_id ?? 'all'}:${category}:${slot}`;
    if (slots.has(key)) {
      error = 'Для одного типа комнаты и назначения можно выбрать только один ассет';
      return;
    }
    slots.add(key);
  });
  return error;
};
